import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions";
import Tabs from "../../components/tabs/Tabs";
import InquiryList from "./components/InquiryList";
import "./MyInquiry.scss";
import { WriteYourQuestion } from "./WriteYourQuestion";
import { TopHeading } from "../../components/heading/TopHeading";

const MyInquiry: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  const topOfPageRef = useRef<HTMLDivElement>(null);

  const { t } = useTranslation();

  useEffect(() => {
    if (topOfPageRef.current) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, []);
  const tabs = [
    {
      label: t("My inquiry"),
      content: <InquiryList />,
    },
    {
      label: t("Frequently asked questions"),
      content: <FrequentlyAskedQuestions />,
    },
  ];

  return (
    <div ref={topOfPageRef} className="my-inquiry ui-container">
      <TopHeading varis={["STICKY", "BLACK_IC"]}>Customized travel</TopHeading>
      <div className=" mt-[5rem] mb-5 sm:my-[5rem] h-auto sm:h-[21.25rem] sm:flex">
        <WriteYourQuestion />
      </div>
      <Tabs
        headerProps={{
          style: { width: "100%", borderColor: "#232323" },
        }}
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
    </div>
  );
};
export default MyInquiry;
